import React, { useMemo } from 'react';
import Badge from '../Badge';
import birthdayIcon from '/img/icons/birthday-no-bg.svg';
import Contact from '@models/Contact';
import styles from './ContactBirthday.module.scss';
import cn from 'classnames';

interface ContactBirthdayProps {
  contact: Contact;
}

export const BirthdayBadge = ({ className }: { className?: string }) => (
  <Badge src={birthdayIcon} className={cn(className)} />
);

export const BirthdayDate = ({ contact }: { contact: Contact }) => {
  const month = useMemo(() => contact.birthMonthAbbreviated, [contact]);
  return (
    <>
      {month} {contact.birthday?.day}
    </>
  );
};

export default function ContactBirthdayBadge({ contact }: ContactBirthdayProps) {
  if (!contact.birthday) {
    return null;
  }

  const age = useMemo(() => contact.age, [contact]);
  const hasAge = !!age && Number(age) > 0;

  return (
    <div className={cn(styles.wrap, hasAge && styles.withAge)}>
      <div className={styles.pill}>
        <BirthdayBadge className={styles.badge} />
        <span className={cn(styles.text, styles.date)}>
          <BirthdayDate contact={contact} />
        </span>
        {hasAge && <span className={cn(styles.text, styles.age)}>{age} years</span>}
      </div>
    </div>
  );
}
